<div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px;">
    <i class="fa-solid fa-calculator" style="font-size: 40px; color: #0d8e8c;"></i>
    <h3>Commission Calculator</h3>
</div>

<form style="width:100%;" #myForm="ngForm">
    <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Listings</mat-label>
            <input matInput 
                   type="number" 
                   [(ngModel)]="listings" 
                   name="listings" 
                   max="300"
                   inputmode="numeric"
                   (ngModelChange)="onValueChange()">
        </mat-form-field>
    </div>

    <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Referrals</mat-label>
            <input matInput 
                   type="number" 
                   [(ngModel)]="referrals" 
                   name="referrals" 
                   max="300"
                   inputmode="numeric"
                   (ngModelChange)="onValueChange()">
        </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 20px; width: 100%;">
        <mat-label style="font-size: 1.2rem; text-align: center;">
            Estimated Commission:<br>
            <span class="success" [appCountUpMoney]="calculatedTotal" [duration]="800" style="font-size: 2.8rem;">
                $0
            </span>
        </mat-label>    
    </div>
</form>